export default {
  chiSiamo: 'Chi siamo',
  organizzazione: 'Organizzazione',
  welfare: 'Welfare',
  selezione: 'Selezione',
  talentDay: 'Talent Day',
}
